export default __webpack_public_path__ + "static/graph-92a5a8f2e0ae926a7fc545bfb173efe2.svg";